import * as actionType from "./constants";
import socketIO from "socket.io-client";
import { remotehost } from "../host";
import { getRooms } from "../rooms/actions";
import { EDIT_ROOM_SUCCESS } from "../rooms/constants";
import {
  EDIT_OCCUPANCY_SUCCESS,
  CREATE_OCCUPANCY_SUCCESS
} from "../rooms/occupancy/constants";
import moment from "moment";
import { CREATE_CLEANING_SUCCESS } from "../cleaning/schedule/constants";

const initializeSocket = (dispatch, getState) => {
  const { selected } = getState().hotels;
  const hotelId = selected;
  const socket = socketIO(remotehost, {
    query: `room=hotel_${hotelId}`
  });

  socket.on("room:change-status", room => {
    dispatch({
      type: EDIT_ROOM_SUCCESS,
      room
    });
  });

  socket.on("room:change-room-info", occupancy => {
    const { date } = getState().occupancy;

    if (date.isSame(moment.utc(occupancy.date), "day")) {
      dispatch({
        type: EDIT_OCCUPANCY_SUCCESS,
        occupancy
      });
    }
  });

  socket.on("room:add-room-info", occupancy => {
    const { date } = getState().occupancy;
    if (date.isSame(moment.utc(occupancy.date), "day")) {
      dispatch({
        type: CREATE_OCCUPANCY_SUCCESS,
        occupancy
      });
    }
  });

  socket.on("roomStatusChange", () => {
    dispatch(getRooms());
  });

  socket.on("cleaning:schedule", cleaning => {
    dispatch({
      type: CREATE_CLEANING_SUCCESS,
      cleaning
    });
  });

  return socket;
};

export const socketConnect = () => {
  return (dispatch, getState) => {
    const socket = initializeSocket(dispatch, getState);

    dispatch({
      type: actionType.SET_CONNECTION,
      payload: socket
    });
  };
};

export const clearMessage = () => ({
  type: actionType.CLEAR_MESSAGE
});

export const setSuccessMessage = message => ({
  type: actionType.SET_MESSAGE,
  payload: {
    message,
    type: "success"
  }
});

export const setWarningMessage = message => ({
  type: actionType.SET_MESSAGE,
  payload: {
    message,
    type: "warning"
  }
});
export const setErrorMessage = message => ({
  type: actionType.SET_MESSAGE,
  payload: {
    message,
    type: "error"
  }
});

export const setIndicate = () => ({
  type: actionType.SET_INDICATE
});

export const toggleMessage = key => ({
  type: actionType.TOGGLE_MESSAGE,
  key
});



// WEBPACK FOOTER //
// ./src/messages/actions.js